import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Connection from '../views/Connection.vue';
import SSOCallback from '../views/SSOCallback.vue';
import MyProjects from '../views/workflow/MyProjects.vue';
import CreateProject from '../views/workflow/CreateProject.vue';
import ProjectScaffold from '../views/workflow/ProjectScaffold.vue';
import ProjectSharedResource from '../views/workflow/ProjectSharedResource.vue';
import EditSharedBriefResource from '../views/workflow/sharing/EditSharedBriefResource.vue';
import Brief from '../views/workflow/brief/Brief.vue';
import EditBrief from '../views/workflow/brief/EditBrief.vue';
import Assets from '../views/workflow/assets/Assets.vue';
import FileRequests from '../views/workflow/assets/FileRequests.vue';
import Production from '../views/workflow/production/Production.vue';
import Delivery from '../views/workflow/delivery/Delivery.vue';
import Documents from '../views/workflow/documents/Documents.vue';
import Details from '../views/workflow/details/Details.vue';
import GeneralInfo from '../views/workflow/details/GeneralInfo.vue';
import ProjectOrigin from '../views/workflow/details/ProjectOrigin.vue';
import ProjectReview from '../views/workflow/details/ProjectReview.vue';
import Feedbacks from "@/views/workflow/Feedbacks";
import TikTok from '@/views/workflow/TikTok.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/signup/callback',
    name: 'sso-callback',
    component: SSOCallback
  },
  {
    path: '/connection',
    name: 'connection',
    component: Connection
  },
  {
    path: '/my-projects/:folder',
    name: 'my-projects',
    component: MyProjects,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/feedbacks',
    name: 'feedbacks',
    component: Feedbacks,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tiktok',
    name: 'tiktok',
    component: TikTok,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/create-project',
    name: 'create-project',
    component: CreateProject,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/sharings/:token/brief',
    name: 'projects.sharings.edit-brief',
    component: EditSharedBriefResource,
    meta: {
      requiresAuth: false,
      showProjectMenu: false
    }
  },
  {
    path: '/projects/sharings/:token',
    name: 'projects.sharings',
    component: ProjectSharedResource,
    meta: {
      requiresAuth: false,
      showProjectMenu: false
    }
  },
  {
    path: '/projects/:projectId',
    name: 'projects',
    component: ProjectScaffold,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/brief',
    name: 'project-brief',
    component: Brief,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/brief/edit',
    name: 'edit-brief',
    component: EditBrief,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/assets',
    name: 'project-assets',
    component: Assets,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/file-requests/:token',
    name: 'project-file-requests',
    component: FileRequests,
    meta: {
      requiresAuth: false,
      showProjectMenu: false
    }
  },
  {
    path: '/projects/:projectId/production',
    name: 'project-production',
    component: Production,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/delivery',
    name: 'project-delivery',
    component: Delivery,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/documents',
    name: 'project-documents',
    component: Documents,
    meta: {
      requiresAuth: true,
      showProjectMenu: true
    }
  },
  {
    path: '/projects/:projectId/details',
    name: 'project-details',
    component: Details,
    meta: {
      requiresAuth: true,
      showProjectMenu: true,
      showProjectDetailsSubMenu: true
    }
  },
  {
    path: '/projects/:projectId/details/general-info',
    name: 'project-details-general-info',
    component: GeneralInfo,
    meta: {
      requiresAuth: true,
      showProjectMenu: true,
      showProjectDetailsSubMenu: true
    }
  },
  {
    path: '/projects/:projectId/details/project-origin',
    name: 'project-details-origin',
    component: ProjectOrigin,
    meta: {
      requiresAuth: true,
      showProjectMenu: true,
      showProjectDetailsSubMenu: true
    }
  },
  {
    path: '/projects/:projectId/details/project-review',
    name: 'project-details-review',
    component: ProjectReview,
    meta: {
      requiresAuth: true,
      showProjectMenu: true,
      showProjectDetailsSubMenu: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('produce-token')) {
      next({ name: 'connection' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
